export const YES_RESPONSE_STATUS = {
  LOGGED_ON: "LOGGED_ON",
  NOT_LOGGED_ON: "NOT_LOGGED_ON",
  SELECT_ANOTHER_BANK: "SELECT_ANOTHER_BANK",
  YES_ERROR_RESPONSE: "YES_ERROR_RESPONSE",
  UNKNOWN: "UNKNOWN",
}
